// apps/web/src/components/online-indicator.tsx
import { cn } from '@viecxanh/chat-ui/utils'

interface OnlineIndicatorProps {
  isOnline: boolean
  className?: string
}

export function OnlineIndicator({ isOnline, className }: OnlineIndicatorProps) {
  return (
    <span
      className={cn(
        'inline-block h-2.5 w-2.5 rounded-full border-2 border-white',
        isOnline ? 'bg-green-500' : 'bg-slate-400',
        className,
      )}
      aria-label={isOnline ? 'Online' : 'Offline'}
    />
  )
}
